module.exports = __webpack_public_path__ + "img/spezialitaetentellerohnehintergrund.00c41331.png";